import SearchRoot from './components/search-root'
import SearchContainer from './components/search-container'
import SearchInput from './components/search-input'
import SearchClearButton from './components/search-clear-button'
import SearchCancelButton from './components/search-cancel-button'
import SearchLeadingIcon from './components/search-leading-icon.jsx'

const SearchComponent = {
  Root: SearchRoot,
  Container: SearchContainer,
  Input: SearchInput,
  ClearButton: SearchClearButton,
  CancelButton: SearchCancelButton,
  LeadingIcon: SearchLeadingIcon
}

export default SearchComponent
